import React from 'react';
import { GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import googleIcon from '../../../../../assets/icons/google.svg';
import appleIcon from '../../../../../assets/icons/apple-only.svg';
import useFitnessVillageCopy from '../../../../../hooks/useFitnessVillageCopy';
import { SurfaceProp } from '../../../../shared/dfcVillage/style';
import { SocialButton, SocialDivider, SocialIcon, SocialRow } from './style';

interface Props extends SurfaceProp {
  loginWithSocialMedia: (provider: GoogleAuthProvider | OAuthProvider) => void;
  isSocialLoading: boolean;
}

/** Google / Apple sign-in. Rendered only when `company.supportSocialAuthentication`. */
const SocialAuthentication: React.FC<Props> = ({
  loginWithSocialMedia,
  isSocialLoading,
  surface,
}) => {
  const copy = useFitnessVillageCopy().auth;
  return (
    <>
      <SocialDivider surface={surface}>{copy.orContinueWith}</SocialDivider>
      <SocialRow>
        <SocialButton
          surface={surface}
          type="button"
          disabled={isSocialLoading}
          onClick={() => loginWithSocialMedia(new GoogleAuthProvider())}
          data-testid="google-auth-button"
        >
          <SocialIcon src={googleIcon} alt="" aria-hidden="true" />
          {copy.google}
        </SocialButton>
        <SocialButton
          surface={surface}
          type="button"
          disabled={isSocialLoading}
          onClick={() => loginWithSocialMedia(new OAuthProvider('apple.com'))}
          data-testid="apple-auth-button"
        >
          <SocialIcon src={appleIcon} alt="" aria-hidden="true" />
          {copy.apple}
        </SocialButton>
      </SocialRow>
    </>
  );
};

export default SocialAuthentication;
